<template>
  <div
    class="m-header"
    :style="{
      height: pxOrVw(extraItem.extras('nav.model')),
      display: extraItem.extras('nav.display') == 1 ? 'block' : 'none',
    }"
  >
    <div class="header-inner">
      <a
        class="logo"
        href="javascript:;"
        :class="extraItem.extras('logo.size')"
        :style="{
          display: extraItem.extras('logo.display') == 1 ? 'block' : 'none',
        }"
      >
        <img :src="extraItem.extras('logo.src')" alt="" />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: ["extras"],
  data() {
    return {
    };
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
